module.exports = "/assets/data/ed7e47bcbd1062fdef9a3093c9e7aef5-SR5.data.json";